import * as actions from "../common/actions";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import AccordionDropdown from "../components/AccordionDropdown";

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    setExpandToState: (id: string, expandState: boolean) => {
      dispatch(actions.updateUi(id, expandState));
      dispatch(actions.searchPush());
    },
  };
}

export default connect(null, mapDispatchToProps)(AccordionDropdown);
